import { questionKeyboardNav } from '@rm-ui/levelling/questionKeyboardNav'

// Keyboard navigation for the levelling-evaluation question steps (PD-1239).
//
// The implementation moved to `shared/ui/src/levelling/questionKeyboardNav.js` so
// rm-portal and rm-portal-beta share one behaviour rather than drifting. This
// wrapper keeps the existing `useQuestionKeyboardNav` import path and name for the
// five call sites here (Track / Zone / SubFactor / Classification / Guided), and
// pins the overlay selector to this portal's Vuetify overlays.
//
// See the shared module for the full contract; params are unchanged.
const VUETIFY_OVERLAY_SELECTOR = '.v-dialog--active, .v-menu__content--active, .v-overlay--active'

export function useQuestionKeyboardNav(options) {
  return questionKeyboardNav({ overlaySelector: VUETIFY_OVERLAY_SELECTOR, ...options })
}
